import { View, Text, Platform } from 'react-native';
import { Link, Stack } from 'expo-router';
import { useStyles } from '../hooks/useStyles';
import { Button } from '../components/ui';
import { Ionicons } from '@expo/vector-icons';
import { addColorOpacity } from '../shared/utils/styles';

export default function NotFoundScreen() {
  const styles = useStyles();
  const { tokens, utils } = styles;

  return (
    <>
      <Stack.Screen options={{ title: 'Page Not Found', headerShown: false }} />
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          padding: utils.spacing['2xl'],
          backgroundColor: tokens.color.background,
        }}
      >
        <View
          style={{
            width: 120,
            height: 120,
            borderRadius: 60,
            backgroundColor: addColorOpacity(tokens.color.error, 0.1),
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: utils.spacing.xl,
          }}
        >
          <Ionicons name="alert-circle-outline" size={64} color={tokens.color.error} />
        </View>

        <Text
          style={{
            fontSize: utils.typography.sizes['4xl'],
            fontWeight: utils.typography.weights.bold,
            color: tokens.color.onBackground,
            fontFamily: utils.typography.heading.fontFamily,
            marginBottom: utils.spacing.md,
            textAlign: 'center',
          }}
        >
          404
        </Text>

        <Text
          style={{
            fontSize: utils.typography.sizes.xl,
            fontWeight: utils.typography.weights.semibold,
            color: tokens.color.onBackground,
            fontFamily: utils.typography.heading.fontFamily,
            marginBottom: utils.spacing.sm,
            textAlign: 'center',
          }}
        >
          Page Not Found
        </Text>

        <Text
          style={{
            fontSize: utils.typography.sizes.base,
            color: addColorOpacity(tokens.color.onBackground, 0.7),
            fontFamily: utils.typography.body.fontFamily,
            textAlign: 'center',
            marginBottom: utils.spacing['2xl'],
            maxWidth: 400,
            lineHeight: utils.typography.sizes.base * 1.6,
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </Text>

        <Link href="/" asChild>
          <Button
            title="Go to Home"
            variant="primary"
            size="lg"
            leftIcon="home-outline"
            onPress={() => {}}
          />
        </Link>

        <View style={{ marginTop: utils.spacing.lg }}>
          <Link href="/(tabs)/home" asChild>
            <Button
              title="Go to Dashboard"
              variant="outline"
              size="md"
              onPress={() => {}}
            />
          </Link>
        </View>
      </View>
    </>
  );
}

